// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
CloudZap by Cloud Serve Pvt. Ltd
*/

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}
.nav ul{
    margin: 0;
   padding: 1vw;
   -webkit-backdrop-filter: blur(5px);
           backdrop-filter: blur(5px);
}
nav ul li {
    display: inline;
    position: relative;
 }
 nav ul li div {
    position: absolute;
    left: -100vw;
    width:50vw;
 }
 nav ul li:hover div {
    left: 0;
 }
 nav ul li ul li {
    display: list-item;
    list-style: none;
    margin: 0;
    padding: 0;
 }
 nav ul li ul{
    display:inline-block;
    margin: 0;
    padding: 20px;
 }
.dropbtn {
    background-color: #fff;
    color:#222;
    padding: 10px;
    font-size: 1.2rem;    
    border: none;
  }
  
  .dropbtn:hover{
   background-color: #fff;
    color: skyblue;
   border-radius: 4px;
   transition: all 0.2s ease-in-out; 
 }
  /* The container <div> - needed to position the dropdown content */
  .dropdown {
    position: relative;
    display: inline-block;
  }
  
  /* Dropdown Content (Hidden by Default) */
  .dropdown-content {
    display: none;
    position: absolute;
    min-width: 200px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }
  
  /* Links inside the dropdown */
  .dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
  }
  
  /* Change color of dropdown links on hover */
  .dropdown-content a:hover {background-color: skyblue;}
  
  /* Show the dropdown menu on hover */
  .dropdown:hover .dropdown-content {display: block;}
  
  /* Change the background color of the dropdown button when the dropdown content is shown */
  .dropdown:hover .dropbtn {background-color:skyblue;}`, "",{"version":3,"sources":["webpack://./src/components/header.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,kCAA0B;UAA1B,0BAA0B;AAC5B;AACA;IACI,SAAS;GACV,YAAY;GACZ,kCAA0B;WAA1B,0BAA0B;AAC7B;AACA;IACI,eAAe;IACf,kBAAkB;CACrB;CACA;IACG,kBAAkB;IAClB,YAAY;IACZ,UAAU;CACb;CACA;IACG,OAAO;CACV;CACA;IACG,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,UAAU;CACb;CACA;IACG,oBAAoB;IACpB,SAAS;IACT,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,YAAY;EACd;;EAEA;GACC,sBAAsB;IACrB,cAAc;GACf,kBAAkB;GAClB,gCAAgC;CAClC;EACC,kEAAkE;EAClE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,yCAAyC;EACzC;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;IAC5C,UAAU;EACZ;;EAEA,8BAA8B;EAC9B;IACE,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;EAChB;;EAEA,4CAA4C;EAC5C,2BAA2B,yBAAyB,CAAC;;EAErD,oCAAoC;EACpC,mCAAmC,cAAc,CAAC;;EAElD,0FAA0F;EAC1F,0BAA0B,wBAAwB,CAAC","sourcesContent":["/*\r\nCloudZap by Cloud Serve Pvt. Ltd\r\n*/\r\n\r\n.sticky {\r\n  position: fixed;\r\n  top: 0;\r\n  width: 100%;\r\n  backdrop-filter: blur(5px);\r\n}\r\n.nav ul{\r\n    margin: 0;\r\n   padding: 1vw;\r\n   backdrop-filter: blur(5px);\r\n}\r\nnav ul li {\r\n    display: inline;\r\n    position: relative;\r\n }\r\n nav ul li div {\r\n    position: absolute;\r\n    left: -100vw;\r\n    width:50vw;\r\n }\r\n nav ul li:hover div {\r\n    left: 0;\r\n }\r\n nav ul li ul li {\r\n    display: list-item;\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n }\r\n nav ul li ul{\r\n    display:inline-block;\r\n    margin: 0;\r\n    padding: 20px;\r\n }\r\n.dropbtn {\r\n    background-color: #fff;\r\n    color:#222;\r\n    padding: 10px;\r\n    font-size: 1.2rem;    \r\n    border: none;\r\n  }\r\n  \r\n  .dropbtn:hover{\r\n   background-color: #fff;\r\n    color: skyblue;\r\n   border-radius: 4px;\r\n   transition: all 0.2s ease-in-out; \r\n }\r\n  /* The container <div> - needed to position the dropdown content */\r\n  .dropdown {\r\n    position: relative;\r\n    display: inline-block;\r\n  }\r\n  \r\n  /* Dropdown Content (Hidden by Default) */\r\n  .dropdown-content {\r\n    display: none;\r\n    position: absolute;\r\n    min-width: 200px;\r\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\r\n    z-index: 1;\r\n  }\r\n  \r\n  /* Links inside the dropdown */\r\n  .dropdown-content a {\r\n    color: black;\r\n    padding: 12px 16px;\r\n    text-decoration: none;\r\n    display: block;\r\n  }\r\n  \r\n  /* Change color of dropdown links on hover */\r\n  .dropdown-content a:hover {background-color: skyblue;}\r\n  \r\n  /* Show the dropdown menu on hover */\r\n  .dropdown:hover .dropdown-content {display: block;}\r\n  \r\n  /* Change the background color of the dropdown button when the dropdown content is shown */\r\n  .dropdown:hover .dropbtn {background-color:skyblue;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
